import React from 'react';
import JustificationContainer from '~/components/atom/JustificationContainer';

const TriggerColumn: React.FC<{
  label?: string;
}> = ({ label }) => {
  if (!label) return null;

  return (
    <JustificationContainer align="center" gap="xs">
      {label.trim()}
    </JustificationContainer>
  );
};

export default TriggerColumn;
